import api from '@/api';
import { getItem } from '../../lang';

export default {
  namespaced: true,

  state: {
    projectStatList: [],
    structureStatList: [],
    measuringPointStatList: [],
    corporationAlertStat: [],
    projectAlertStat: [],
    projectDeviceHealthStatList: [],
    // 监测概况数据
    projectMeasurementValueList: [],
  },

  getters: {
    projectStructuresStat: (state) => {
      return (projectId) => {
        return state.structureStatList.filter(item => item.projectId === projectId);
      };
    },
    projectMeasuringPointsStat: (state) => {
      return (projectId) => {
        return state.measuringPointStatList.filter(item => item.projectId === projectId);
      };
    },
    projectStat: (state) => {
      return (projectId) => {
        return state.projectStatList.find(item => item.projectId === projectId);
      };
    },
  },

  actions: {
    async GetCorporationStat({ commit }) {
      const {
        projectStatList, structureStatList, measuringPointStatList,
      } = await api.stat.getCorporationStat();
      commit('SET_PROJECT_STAT_LIST', projectStatList);
      commit('SET_STRUCTURE_STAT_LIST', structureStatList);
      commit('SET_MEASURING_POINT_STAT_LIST', measuringPointStatList);
    },
    async GetCorporationAlertStat({ commit }) {
      const { alertStatusStat } = await api.stat.getAlertStatusStat();
      let total = 0;
      const stat = alertStatusStat.map((item) => {
        const { status, count } = item;
        total += count;
        return { name: getItem('dync').alarmStatus[status], value: count };
      });
      const home = getItem('home');
      commit('SET_CORPORATION_ALERT_STAT', [{ name: home.historyAlarm, value: total }, ...stat]);
    },
    async GetProjectAlertStat({ commit }, projectId) {
      const { alertStatusStat } = await api.stat.getAlertStatusStat({ projectId });
      let total = 0;
      const stat = alertStatusStat.map((item) => {
        const { status, count } = item;
        total += count;
        return { name: getItem('dync').alarmStatus[status], value: count };
      });
      const home = getItem('home');
      commit('SET_PROJECT_ALERT_STAT', [{ name: home.historyAlarm, value: total }, ...stat]);
    },
    async GetProjectDeviceStat({ commit }, projectId) {
      const { deviceHealthStatList } = await api.stat.getDeviceHealthStat({ projectId });
      commit('SET_PROJECT_DEVICE_HEALTH_STAT_LIST', deviceHealthStatList);
    },
    // 获取项目监测概况数据（结构物、测点、变化值、变化速率、报警值、报警状态...）
    async GetProjectMeasurementValueStat({ commit }, projectId) {
      const { measurementValueList } = await api.stat.getMeasurementValueStat({ projectId });
      commit('SET_PROJECT_MEASUREMENT_VALUE_LIST', measurementValueList);
    },
  },
  mutations: {
    SET_PROJECT_STAT_LIST(state, stat) {
      state.projectStatList = stat;
    },
    SET_STRUCTURE_STAT_LIST(state, stat) {
      state.structureStatList = stat;
    },
    SET_MEASURING_POINT_STAT_LIST(state, stat) {
      state.measuringPointStatList = stat;
    },
    SET_CORPORATION_ALERT_STAT(state, stat) {
      state.corporationAlertStat = stat;
    },
    SET_PROJECT_ALERT_STAT(state, stat) {
      state.projectAlertStat = stat;
    },
    SET_PROJECT_DEVICE_HEALTH_STAT_LIST(state, stat) {
      state.projectDeviceHealthStatList = stat;
    },
    SET_PROJECT_MEASUREMENT_VALUE_LIST(state, stat) {
      state.projectMeasurementValueList = stat;
    },
  },
};
